<template>
  <v-form ref="PAIEMENT" lazy-validation>

    <div class="p-3">
      <section-header :ressource="ressource"
                      :dialog="true"
                      @closeDialog=closeDialog
                      ref="PAIEMENT">
      </section-header>
    </div>

    <component ref="SECTION_DIALOG" :is="section.component" v-bind="currentProperties" v-on="events"></component>

  </v-form>
</template>

<script lang="ts">
import Section from '@/framework/base/classes/Section';
import SectionRib from '@/extend/sections/SectionRibExtend.vue';
import { storeRib } from '@/generated/stores';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import { RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
import Owner from '@/generated/classes/Owner';
import SelectField from '@/framework/base/components/SelectField.vue';
import { EditFieldTheme } from '@/framework/base/components/FieldInfo';
import PaymentMeans from '@/generated/classes/PaymentMeans';
import { defineComponent, type PropType } from "vue";

export default defineComponent({
  components: {
    SectionHeader,
    SelectField
  },
  props: {
    hideTitle: {
      type: Boolean
    },
    owner: {
      type: Object as PropType<Owner>,
      required: true
    },
    theme: {
      type: Object as PropType<EditFieldTheme>
    },
    paymentMeans: {
      type: Object as PropType<PaymentMeans>
    }
  },
  computed: {
    ressource() {
      return RessourceFwkSection(FwkSections.PAYMENT)
    },
    section(): Section {
      const section = new Section();
      section.ressource = this.ressource;
      section.component = SectionRib;
      const ribId = this.paymentMeans ? this.paymentMeans.typeId : 0;
      const rib = storeRib.getRib(ribId);
      rib.owner = this.owner;
      section.data = rib;
      section.type = 'rib';
      section.showButton = true;
      section.autoSave = true;
      return section;
    },
    currentProperties() {
      return {
        section: this.section,
        [this.section.type]: this.section.data,
        type: this.section.type,
        data: this.section.data,
        [this.section.propType]: this.section.propData,
        autoClear: this.section.autoClear,
        ressource: this.section.ressource,
        picto: this.section.picto,
        contextId: this.section.contextId,
        buttons: this.section.buttons,
        extended: true,
        closeSection: false,
        dialog: true,
        autoClose: true,
        hideTitle: true,
        showButton: this.section.showButton,
        autoSave: this.section.autoSave,
      };
    },
    events(): Record<string, () => void> {
      // eslint-disable-next-line
      const event: any = {};
      event["closeDialog"] = () => this.closeDialog();
      // eslint-disable-next-line
      event["updated"] = (value: any) => this.setUpdated(value);
      return event;
    }
  },
  methods: {
    setUpdated(value: any): void {
      this.$emit('updated', value);
    },
    closeDialog(): void {
      this.$emit('closeDialog')
    }
  }
})

</script>
